var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"select",style:(_vm.style),attrs:{"items":_vm.items,"value":_vm.value,"hide-details":"","dense":"","outlined":"","menu-props":{ offsetY: true }},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }